export function getSupportedMimeTypes() {
    const mimeTypes = ['image/jpeg', 'image/png'];
    return mimeTypes;
}
export const isSupportedDataSource = (data) => {
    const supportedMimeTypes = getSupportedMimeTypes();
    return (data &&
        supportedMimeTypes.indexOf(data.type) > -1 &&
        data.size <= configGet('fileUploadMaxSize', 1e6));
};
